export const PORTFOLIO_ITEMS = [  {
    id: "mm-summer-special",
    category: "murano",
    image: "/images/mm-summer-special.jpg",
    year: "2023",
    client: "SM3000 · MurrinaMurano",
    span: "md:col-span-5",
    aspect: "aspect-[3/4]",
    title: { it: "Summer Special Edition", en: "Summer Special Edition" },
    desc: {
      it: "Catena dorata e maglie di vetro avorio su legno di mare: l'estate in laguna.",
      en: "Golden chain and ivory glass links on driftwood: summer in the lagoon.",
    },
    materials: { it: "Vetro di Murano, catena dorata", en: "Murano glass, gilt chain" },
  },
  {
    id: "mm-scura",
    category: "murano",
    image: "/images/mm-scura.jpg",
    year: "2026/27",
    client: "SM3000 · MurrinaMurano",
    span: "md:col-span-7",
    aspect: "aspect-[4/5]",
    title: { it: "Collezione Autunno-Inverno 2026/27", en: "Autumn-Winter 2026/27 Collection" },
    desc: {
      it: "Parure di dischi in vetro blu e ambra su fondo scuro: il vetro come pittura di luce.",
      en: "A parure of blue and amber glass discs on a dark backdrop: glass as a painting of light.",
    },
    materials: { it: "Vetro di Murano, oro", en: "Murano glass, gold" },
  },
  {
    id: "mm-aw2627-b",
    category: "murano",
    image: "/images/mm-aw2627-b.jpg",
    year: "2026/27",
    client: "SM3000 · MurrinaMurano",
    span: "md:col-span-7",
    aspect: "aspect-[4/5]",
    title: { it: "Collezione Autunno-Inverno 2026/27", en: "Autumn-Winter 2026/27 Collection" },
    desc: {
      it: "Charms dorati e ambra su top bianco: luce calda d'autunno.",
      en: "Golden and amber charms on a white top: warm autumn light.",
    },
    materials: { it: "Vetro di Murano, oro", en: "Murano glass, gold" },
  },
  {
    id: "mm-aw2627-c",
    category: "murano",
    image: "/images/mm-aw2627-c.jpg",
    year: "2026/27",
    client: "SM3000 · MurrinaMurano",
    span: "md:col-span-5",
    aspect: "aspect-[3/4]",
    title: { it: "Collezione Autunno-Inverno 2026/27", en: "Autumn-Winter 2026/27 Collection" },
    desc: {
      it: "Dischi di vetro blu e verde salvia con bracciale coordinato.",
      en: "Blue and sage-green glass discs with a matching bracelet.",
    },
    materials: { it: "Vetro di Murano, catena dorata", en: "Murano glass, gilt chain" },
  },
  {
    id: "mm-aw2627-d",
    category: "murano",
    image: "/images/mm-aw2627-d.jpg",
    year: "2026/27",
    client: "SM3000 · MurrinaMurano",
    span: "md:col-span-7",
    aspect: "aspect-[4/5]",
    title: { it: "Collezione Autunno-Inverno 2026/27", en: "Autumn-Winter 2026/27 Collection" },
    desc: {
      it: "Collana lunga blu e viola su dolcevita marrone: ritmo verticale.",
      en: "A long blue and purple necklace on a brown turtleneck: vertical rhythm.",
    },
    materials: { it: "Vetro di Murano, oro", en: "Murano glass, gold" },
  },
  {
    id: "mm-aw2627-e",
    category: "murano",
    image: "/images/mm-aw2627-e.jpg",
    year: "2026/27",
    client: "SM3000 · MurrinaMurano",
    span: "md:col-span-5",
    aspect: "aspect-[3/4]",
    title: { it: "Collezione Autunno-Inverno 2026/27", en: "Autumn-Winter 2026/27 Collection" },
    desc: {
      it: "Primo piano con orecchino a goccia: il dettaglio come firma.",
      en: "Close-up with a teardrop earring: detail as a signature.",
    },
    materials: { it: "Vetro di Murano, oro", en: "Murano glass, gold" },
  },
  {
    id: "mm-ss2026",
    category: "murano",
    image: "/images/mm-ss2026.jpg",
    year: "2026",
    client: "SM3000 · MurrinaMurano",
    span: "md:col-span-5",
    aspect: "aspect-[3/4]",
    title: { it: "Collezione Primavera-Estate 2026", en: "Spring-Summer 2026 Collection" },
    desc: {
      it: "Perle di vetro rosso tra cesto di vimini e tovaglia a quadri: un picnic veneziano.",
      en: "Red glass pearls between a wicker basket and gingham cloth: a Venetian picnic.",
    },
    materials: { it: "Vetro di Murano, oro", en: "Murano glass, gold" },
  },
  {
    id: "mm-ss2025",
    category: "murano",
    image: "/images/mm-ss2025.jpg",
    year: "2025",
    client: "SM3000 · MurrinaMurano",
    span: "md:col-span-7",
    aspect: "aspect-[16/10]",
    title: { it: "Collezione Primavera-Estate 2025", en: "Spring-Summer 2025 Collection" },
    desc: {
      it: "Parure di vetro verde e rosa tra le foglie: la primavera in serra.",
      en: "A green and pink glass parure among the leaves: springtime in the greenhouse.",
    },
    materials: { it: "Vetro di Murano", en: "Murano glass" },
  },
  {
    id: "mm-mare",
    category: "murano",
    image: "/images/mm-mare.jpg",
    year: "2023",
    client: "SM3000 · MurrinaMurano",
    span: "md:col-span-7",
    aspect: "aspect-[16/11]",
    title: { it: "Collezione Primavera-Estate 2023", en: "Spring-Summer 2023 Collection" },
    desc: {
      it: "Collana di perle in vetro dai toni del mare indossata sulla battigia: la luce della laguna diventa gioiello.",
      en: "A necklace of sea-toned glass pearls worn by the shore: the light of the lagoon becomes jewelry.",
    },
    materials: { it: "Vetro di Murano, argento", en: "Murano glass, silver" },
  },
  {
    id: "mm-turchese",
    category: "murano",
    image: "/images/mm-turchese.jpg",
    year: "2023",
    client: "SM3000 · MurrinaMurano",
    span: "md:col-span-5",
    aspect: "aspect-[3/4]",
    title: { it: "Collezione Primavera-Estate 2023", en: "Spring-Summer 2023 Collection" },
    desc: {
      it: "Primo piano su orecchino in perle di vetro turchese: il dettaglio come protagonista assoluto.",
      en: "Close-up on a turquoise glass pearl earring: detail as the absolute protagonist.",
    },
    materials: { it: "Vetro di Murano, monachella in argento", en: "Murano glass, silver hook" },
  },
  {
    id: "mm-nero-petrolio",
    category: "murano",
    image: "/images/mm-nero-petrolio.jpg",
    year: "2023",
    client: "SM3000 · MurrinaMurano",
    span: "md:col-span-5",
    aspect: "aspect-[3/4]",
    title: { it: "Collezione Primavera-Estate 2023", en: "Spring-Summer 2023 Collection" },
    desc: {
      it: "Collana di gocce in vetro verde petrolio su maglia nera: eleganza grafica da sera.",
      en: "A necklace of petrol-green glass drops on black knit: graphic evening elegance.",
    },
    materials: { it: "Vetro di Murano, catena dorata", en: "Murano glass, gilt chain" },
  },
  {
    id: "mm-bracciale",
    category: "murano",
    image: "/images/mm-pietra.jpg",
    year: "2023",
    client: "SM3000 · MurrinaMurano",
    span: "md:col-span-7",
    aspect: "aspect-[4/5]",
    title: { it: "Collezione Primavera-Estate 2023", en: "Spring-Summer 2023 Collection" },
    desc: {
      it: "Perle in vetro azzurro e crema con chiusura a T dorata: il prodotto nella sua forma più pura.",
      en: "Sky-blue and cream glass pearls with a golden T-clasp: the product in its purest form.",
    },
    materials: { it: "Vetro di Murano, metallo dorato", en: "Murano glass, gilt metal" },
  },
  {
    id: "murrina-ritratto",
    category: "murano",
    image: "/images/murrina-detail.jpg",
    year: "2014",
    client: "SM3000 · MurrinaMurano",
    span: "md:col-span-5",
    aspect: "aspect-[3/4]",
    title: { it: "Collezione Autunno-Inverno 2022/23", en: "Autumn-Winter 2022/23 Collection" },
    desc: {
      it: "Il dettaglio come architettura: murrine veneziane e filo d'oro costruiscono volumi leggeri sul corpo.",
      en: "Detail as architecture: Venetian murrine and gold thread build weightless volumes on the body.",
    },
    materials: { it: "Murrine, oro", en: "Murrine, gold" },
  },
  {
    id: "mm-ambra",
    category: "murano",
    image: "/images/mm-ambra.jpg",
    year: "2021/22",
    client: "SM3000 · MurrinaMurano",
    span: "md:col-span-5",
    aspect: "aspect-[3/4]",
    title: { it: "Collezione Autunno-Inverno 2021/22", en: "Autumn-Winter 2021/22 Collection" },
    desc: {
      it: "Pietre di vetro ambra e acquamarina su parete veneziana: geometrie liquide al collo.",
      en: "Amber and aquamarine glass stones against a Venetian wall: liquid geometries on the neck.",
    },
    materials: { it: "Vetro di Murano, metallo", en: "Murano glass, metal" },
  },
  {
    id: "bab-estate-2015",
    category: "bags",
    image: "/images/bab-estate-2015.jpg",
    year: "2015",
    client: "BAB — Build A Bag",
    span: "md:col-span-12",
    aspect: "aspect-[3045/1935]",
    title: { it: "Build A Bag", en: "Build A Bag" },
    desc: {
      it: "La presentazione Ready to Go Estate 2015: palette di pelli metallizzate e camoscio, sacco modulare e manici intercambiabili.",
      en: "The Ready to Go Summer 2015 presentation: metallic and suede leather palettes, modular body and interchangeable handles.",
    },
    materials: { it: "Pelle, camoscio, canvas", en: "Leather, suede, canvas" },
  },
  {
    id: "bab-bag-010",
    category: "bags",
    image: "/images/bab-bag-010.jpg",
    year: "2015",
    client: "BAB — Build A Bag",
    span: "md:col-span-6",
    aspect: "aspect-[1600/2397]",
    title: { it: "Build A Bag", en: "Build A Bag" },
    desc: {
      it: "BAB in pelle marrone con tasche nere e manici taupe: la borsa modulare nella sua configurazione essenziale.",
      en: "BAB in brown leather with black pockets and taupe handles: the modular bag in its essential configuration.",
    },
    materials: { it: "Pelle, camoscio", en: "Leather, suede" },
  },
  {
    id: "bab-bag-011",
    category: "bags",
    image: "/images/bab-bag-011.jpg",
    year: "2015",
    client: "BAB — Build A Bag",
    span: "md:col-span-6",
    aspect: "aspect-[1600/2397]",
    title: { it: "Build A Bag", en: "Build A Bag" },
    desc: {
      it: "BAB con pannelli giallo ocra e manici neri: il sistema modulare cambia carattere in un gesto.",
      en: "BAB with ochre-yellow panels and black handles: the modular system changes character in one gesture.",
    },
    materials: { it: "Pelle, camoscio", en: "Leather, suede" },
  },
  {
    id: "bab-bag-017",
    category: "bags",
    image: "/images/bab-bag-017.jpg",
    year: "2015",
    client: "BAB — Build A Bag",
    span: "md:col-span-6",
    aspect: "aspect-[1600/2397]",
    title: { it: "Build A Bag", en: "Build A Bag" },
    desc: {
      it: "BAB con pannello blu petrolio e tasche gialle, manici rosso mattone: colore e geometria in libertà.",
      en: "BAB with petrol-blue panel and yellow pockets, brick-red handles: colour and geometry in freedom.",
    },
    materials: { it: "Pelle, camoscio", en: "Leather, suede" },
  },
  {
    id: "bab-bag-018",
    category: "bags",
    image: "/images/bab-bag-018.jpg",
    year: "2015",
    client: "BAB — Build A Bag",
    span: "md:col-span-6",
    aspect: "aspect-[1600/2397]",
    title: { it: "Build A Bag", en: "Build A Bag" },
    desc: {
      it: "BAB in camoscio testa di moro con pannello blu cobalto e tasche caramello: eleganza quotidiana.",
      en: "BAB in dark brown suede with cobalt-blue panel and caramel pockets: everyday elegance.",
    },
    materials: { it: "Pelle, camoscio", en: "Leather, suede" },
  },
  {
    id: "bab-pieghevole",
    category: "bags",
    image: "/images/bab-pieghevole.jpg",
    year: "2015",
    client: "BAB — Build A Bag",
    span: "md:col-span-12",
    aspect: "aspect-[6729/2192]",
    title: { it: "Build A Bag", en: "Build A Bag" },
    desc: {
      it: "Il pieghevole fronte/retro di BAB: tutte le combinazioni della linea Caleidos in un unico sguardo, con la storia del progetto.",
      en: "The BAB front/back leaflet: all the Caleidos line combinations at a glance, with the story of the project.",
    },
    materials: { it: "Stampa, grafica", en: "Print, graphic design" },
  },
  {
    id: "caleidos-borsa",
    category: "bags",
    image: "/images/caleidos-borsa.jpg",
    year: "2013",
    client: "BAB — Build A Bag",
    span: "md:col-span-6 md:col-start-4",
    aspect: "aspect-[2339/3308]",
    title: { it: "Caleidos", en: "Caleidos" },
    desc: {
      it: "La shopper Caleidos in pelle nera con dischi applicati: moltiplica i tuoi desideri.",
      en: "The Caleidos shopper in black leather with applied discs: multiply your desires.",
    },
    materials: { it: "Pelle, bottoni metallici", en: "Leather, metal buttons" },
  },
  {
    id: "mela-young-red",
    category: "mela",
    image: "/images/mela-young-red.jpg",
    year: "Archivio",
    client: "Mela",
    span: "md:col-span-7",
    aspect: "aspect-[1600/1115]",
    title: { it: "Young — Collana Red", en: "Young — Red Necklace" },
    desc: {
      it: "Collana Young in rosso: anelli di vetro dal segno grafico, energia immediata.",
      en: "Young necklace in red: graphic glass rings, immediate energy.",
    },
    materials: { it: "Vetro di Murano, pelle", en: "Murano glass, leather" },
  },
  {
    id: "mela-young001-red",
    category: "mela",
    image: "/images/mela-young001-red.jpg",
    year: "Archivio",
    client: "Mela",
    span: "md:col-span-5",
    aspect: "aspect-[1224/1600]",
    title: { it: "Young — Rosso", en: "Young — Red" },
    desc: {
      it: "La linea Young in rosso indossata: vetro e colore in primo piano.",
      en: "The Young line in red, worn: glass and colour up close.",
    },
    materials: { it: "Vetro di Murano, pelle", en: "Murano glass, leather" },
  },
  {
    id: "mela-young002-arancio",
    category: "mela",
    image: "/images/mela-young002-arancio.jpg",
    year: "Archivio",
    client: "Mela",
    span: "md:col-span-7",
    aspect: "aspect-[1600/1098]",
    title: { it: "Young — Arancio", en: "Young — Orange" },
    desc: {
      it: "Young in chiave pop: vetro arancio e segno grafico.",
      en: "Young goes pop: orange glass and graphic gesture.",
    },
    materials: { it: "Vetro di Murano, pelle", en: "Murano glass, leather" },
  },
  {
    id: "mela-re009",
    category: "mela",
    image: "/images/mela-re009.jpg",
    year: "Archivio",
    client: "Mela",
    span: "md:col-span-5",
    aspect: "aspect-[1600/1504]",
    title: { it: "Re 009", en: "Re 009" },
    desc: {
      it: "Composizione della linea Re: geometrie di vetro in equilibrio.",
      en: "A composition from the Re line: glass geometries in balance.",
    },
    materials: { it: "Vetro di Murano, pelle", en: "Murano glass, leather" },
  },
  {
    id: "mela-re003",
    category: "mela",
    image: "/images/mela-re003.jpg",
    year: "Archivio",
    client: "Mela",
    span: "md:col-span-5",
    aspect: "aspect-[1446/1600]",
    title: { it: "Re 003", en: "Re 003" },
    desc: {
      it: "Linea Re: il vetro di Murano in forme essenziali.",
      en: "The Re line: Murano glass in essential forms.",
    },
    materials: { it: "Vetro di Murano, pelle", en: "Murano glass, leather" },
  },
  {
    id: "mela-lana",
    category: "mela",
    image: "/images/mela-lana.jpg",
    year: "Archivio",
    client: "Mela",
    span: "md:col-span-7",
    aspect: "aspect-[1600/1417]",
    title: { it: "Lana", en: "Lana" },
    desc: {
      it: "La linea Lana: morbidezza della fibra e luce del vetro.",
      en: "The Lana line: the softness of fibre meets the light of glass.",
    },
    materials: { it: "Vetro di Murano, pelle", en: "Murano glass, leather" },
  },
  {
    id: "mela-infinity",
    category: "mela",
    image: "/images/mela-infinity.jpg",
    year: "Archivio",
    client: "Mela",
    span: "md:col-span-6",
    aspect: "aspect-[3/4]",
    title: { it: "Infinity", en: "Infinity" },
    desc: {
      it: "Infinity: il cerchio come modulo infinito, vetro in movimento continuo.",
      en: "Infinity: the circle as an infinite module, glass in continuous motion.",
    },
    materials: { it: "Vetro di Murano, pelle", en: "Murano glass, leather" },
  },
  {
    id: "mela-infinity-2",
    category: "mela",
    image: "/images/mela-infinity-2.jpg",
    year: "Archivio",
    client: "Mela",
    span: "md:col-span-6",
    aspect: "aspect-[3/4]",
    title: { it: "Infinity II", en: "Infinity II" },
    desc: {
      it: "Seconda variazione della linea Infinity: ritmo e trasparenza.",
      en: "A second variation of the Infinity line: rhythm and transparency.",
    },
    materials: { it: "Vetro di Murano, pelle", en: "Murano glass, leather" },
  },
  {
    id: "mela-philum",
    category: "mela",
    image: "/images/mela-philum.jpg",
    year: "Archivio",
    client: "Mela",
    span: "md:col-span-6",
    aspect: "aspect-[1221/1600]",
    title: { it: "Philum", en: "Philum" },
    desc: {
      it: "Philum: filo e vetro intrecciati in una struttura leggera.",
      en: "Philum: thread and glass woven into a weightless structure.",
    },
    materials: { it: "Vetro di Murano, pelle", en: "Murano glass, leather" },
  },
  {
    id: "mela-andromeda-005",
    category: "mela",
    image: "/images/mela-andromeda-005.jpg",
    year: "Archivio",
    client: "Mela",
    span: "md:col-span-6",
    aspect: "aspect-[1067/1600]",
    title: { it: "Andromeda", en: "Andromeda" },
    desc: {
      it: "Bracciale Andromeda: nastri annodati in una spirale morbida, gioiello tattile.",
      en: "Andromeda bracelet: ribbons knotted into a soft spiral — a tactile jewel.",
    },
    materials: { it: "Vetro di Murano, pelle", en: "Murano glass, leather" },
  },
  {
    id: "mela-chicca-lunga",
    category: "mela",
    image: "/images/mela-chicca-lunga.jpg",
    year: "Archivio",
    client: "Mela",
    span: "md:col-span-6",
    aspect: "aspect-[3/4]",
    title: { it: "Chicca Lunga", en: "Chicca Lunga" },
    desc: {
      it: "Collana Chicca in versione lunga: verticalità elegante.",
      en: "The Chicca necklace in its long version: elegant verticality.",
    },
    materials: { it: "Vetro di Murano, pelle", en: "Murano glass, leather" },
  },
  {
    id: "mela-luna-lilla",
    category: "mela",
    image: "/images/mela-luna-lilla.jpg",
    year: "Archivio",
    client: "Mela",
    span: "md:col-span-6",
    aspect: "aspect-[3/4]",
    title: { it: "Luna Lilla", en: "Luna Lilla" },
    desc: {
      it: "Luna Lilla: toni lilla e luce lunare nel vetro.",
      en: "Luna Lilla: lilac tones and moonlight in glass.",
    },
    materials: { it: "Vetro di Murano, pelle", en: "Murano glass, leather" },
  },
  {
    id: "mela-roller",
    category: "mela",
    image: "/images/mela-roller.jpg",
    year: "Archivio",
    client: "Mela",
    span: "md:col-span-6",
    aspect: "aspect-[3/4]",
    title: { it: "Roller — Bracciale", en: "Roller — Bracelet" },
    desc: {
      it: "Bracciale Roller: elementi in vetro che scorrono come piccole ruote di colore.",
      en: "Roller bracelet: glass elements rolling like small wheels of colour.",
    },
    materials: { it: "Vetro di Murano, pelle", en: "Murano glass, leather" },
  },
  {
    id: "mela-anelli-pop-2",
    category: "mela",
    image: "/images/mela-anelli-pop-2.jpg",
    year: "Archivio",
    client: "Mela",
    span: "md:col-span-6",
    aspect: "aspect-square",
    title: { it: "Anelli Pop", en: "Pop Rings" },
    desc: {
      it: "Anelli Pop: fiori di pelle e bottoni, piccoli giardini da portare al dito.",
      en: "Pop rings: leather flowers and buttons — tiny gardens to wear on your finger.",
    },
    materials: { it: "Vetro di Murano, pelle", en: "Murano glass, leather" },
  },
  {
    id: "mela-bracciale-cross",
    category: "mela",
    image: "/images/mela-bracciale-cross.jpg",
    year: "Archivio",
    client: "Mela",
    span: "md:col-span-6",
    aspect: "aspect-square",
    title: { it: "Bracciale Cross", en: "Cross Bracelet" },
    desc: {
      it: "Bracciale Cross: incroci di pelle e vetro in un segno deciso.",
      en: "Cross bracelet: intersections of leather and glass in a bold gesture.",
    },
    materials: { it: "Vetro di Murano, pelle", en: "Murano glass, leather" },
  },
  {
    id: "mela-pop-bracciale",
    category: "mela",
    image: "/images/mela-pop-bracciale.jpg",
    year: "Archivio",
    client: "Mela",
    span: "md:col-span-6",
    aspect: "aspect-[3/4]",
    title: { it: "Pop — Bracciale", en: "Pop — Bracelet" },
    desc: {
      it: "Bracciale Pop: il fiore di pelle diventa polso, colore quotidiano.",
      en: "Pop bracelet: the leather flower moves to the wrist, everyday colour.",
    },
    materials: { it: "Vetro di Murano, pelle", en: "Murano glass, leather" },
  },
  {
    id: "mela-carla-lunga",
    category: "mela",
    image: "/images/mela-carla-lunga.jpg",
    year: "Archivio",
    client: "Mela",
    span: "md:col-span-6",
    aspect: "aspect-[591/886]",
    title: { it: "Carla — Collana Lunga", en: "Carla — Long Necklace" },
    desc: {
      it: "Collana Carla in versione lunga: il best-seller Mela in verticale.",
      en: "The Carla necklace in its long version: Mela's best-seller goes vertical.",
    },
    materials: { it: "Vetro di Murano, pelle", en: "Murano glass, leather" },
  },
  {
    id: "mela-carla-alto",
    category: "mela",
    image: "/images/mela-carla-alto.jpg",
    year: "Archivio",
    client: "Mela",
    span: "md:col-span-6",
    aspect: "aspect-square",
    title: { it: "Carla — Bracciale", en: "Carla — Bracelet" },
    desc: {
      it: "Bracciale Carla: la stessa architettura della collana, al polso.",
      en: "Carla bracelet: the same architecture as the necklace, on the wrist.",
    },
    materials: { it: "Vetro di Murano, pelle", en: "Murano glass, leather" },
  },
  {
    id: "mela-bracciale-fiori",
    category: "mela",
    image: "/images/mela-bracciale-fiori.jpg",
    year: "Archivio",
    client: "Mela",
    span: "md:col-span-6",
    aspect: "aspect-square",
    title: { it: "Bracciale Fiori", en: "Flower Bracelet" },
    desc: {
      it: "Bracciale con fiori di vetro: un piccolo giardino veneziano al polso.",
      en: "A bracelet with glass flowers: a small Venetian garden on the wrist.",
    },
    materials: { it: "Vetro di Murano, pelle", en: "Murano glass, leather" },
  },
  {
    id: "mela-fly-due-fiori",
    category: "mela",
    image: "/images/mela-fly-due-fiori.jpg",
    year: "Archivio",
    client: "Mela",
    span: "md:col-span-6",
    aspect: "aspect-square",
    title: { it: "Fly — Due Fiori", en: "Fly — Two Flowers" },
    desc: {
      it: "Bracciale Fly con due fiori di vetro satinato: delicatezza botanica.",
      en: "Fly bracelet with two satin glass flowers: botanical delicacy.",
    },
    materials: { it: "Vetro di Murano, pelle", en: "Murano glass, leather" },
  },
  {
    id: "mela-libellule",
    category: "mela",
    image: "/images/mela-libellule.jpg",
    year: "Archivio",
    client: "Mela",
    span: "md:col-span-6",
    aspect: "aspect-square",
    title: { it: "Tre Libellule", en: "Three Dragonflies" },
    desc: {
      it: "Collana con tre libellule di vetro: ali leggere sospese al collo.",
      en: "A necklace with three glass dragonflies: light wings suspended on the neck.",
    },
    materials: { it: "Vetro di Murano, pelle", en: "Murano glass, leather" },
  },
  {
    id: "mela-fly-tre-farfalle",
    category: "mela",
    image: "/images/mela-fly-tre-farfalle.jpg",
    year: "Archivio",
    client: "Mela",
    span: "md:col-span-6",
    aspect: "aspect-square",
    title: { it: "Fly — Tre Farfalle", en: "Fly — Three Butterflies" },
    desc: {
      it: "Collana Fly con tre farfalle: ali di vetro leggere come carta.",
      en: "Fly necklace with three butterflies: glass wings light as paper.",
    },
    materials: { it: "Vetro di Murano, pelle", en: "Murano glass, leather" },
  },
  {
    id: "gliori-alyssa",
    category: "gliori",
    image: "/images/gliori-alyssa.jpg",
    year: "2016",
    client: "Gli Ori di Venezia",
    span: "md:col-span-7",
    aspect: "aspect-[16/10]",
    title: { it: "Collaborazione 2014/15", en: "Collaboration 2014/15" },
    desc: {
      it: "Anelli concatenati in vetro trasparente e colorato per Gli Ori di Venezia: il cerchio come modulo infinito.",
      en: "Linked rings in transparent and coloured glass for Gli Ori di Venezia: the circle as an infinite module.",
    },
    materials: { it: "Vetro di Murano lavorato a lume", en: "Lampworked Murano glass" },
  },
  {
    id: "gliori-dafne",
    category: "gliori",
    image: "/images/gliori-dafne.jpg",
    year: "2016",
    client: "Gli Ori di Venezia",
    span: "md:col-span-5",
    aspect: "aspect-[16/10]",
    title: { it: "Collaborazione 2014/15", en: "Collaboration 2014/15" },
    desc: {
      it: "Parure Dafne: petali di vetro acquamarina in collana, orecchini e bracciale — la luce della laguna.",
      en: "Dafne parure: aquamarine glass petals in necklace, earrings and bracelet — the light of the lagoon.",
    },
    materials: { it: "Vetro di Murano", en: "Murano glass" },
  },
  {
    id: "vaccari-onde",
    category: "vaccari",
    image: "/images/vaccari-onde.jpg",
    year: "2012",
    client: "Antonio Vaccari",
    span: "md:col-span-7",
    aspect: "aspect-[16/11]",
    title: { it: "Collaborazione 2013/14", en: "Collaboration 2013/14" },
    desc: {
      it: "Collana a onda nera con perle rosa e cristallo per Antonio Vaccari: ritmo e movimento sulla pelle.",
      en: "A black wave necklace with pink pearls and crystal for Antonio Vaccari: rhythm and movement on the skin.",
    },
    materials: { it: "Vetro di Murano, cristallo", en: "Murano glass, crystal" },
  },
  {
    id: "vaccari-blu",
    category: "vaccari",
    image: "/images/vaccari-blu.jpg",
    year: "2012",
    client: "Antonio Vaccari",
    span: "md:col-span-5",
    aspect: "aspect-[3/4]",
    title: { it: "Collaborazione 2013/14", en: "Collaboration 2013/14" },
    desc: {
      it: "Cascate di perle in vetro blu e turchese: la tradizione della perla veneziana in chiave contemporanea.",
      en: "Cascades of blue and turquoise glass pearls: the Venetian pearl tradition in a contemporary key.",
    },
    materials: { it: "Vetro di Murano", en: "Murano glass" },
  },
  {
    id: "gliori-lilia",
    category: "gliori",
    image: "/images/gliori-lilia.jpg",
    year: "2016",
    client: "Gli Ori di Venezia",
    span: "md:col-span-6",
    aspect: "aspect-[16/10]",
    title: { it: "Collaborazione 2014/15", en: "Collaboration 2014/15" },
    desc: {
      it: "Parure di petali in vetro rosa e cipria con perline d'argento: delicatezza botanica in collana e orecchini.",
      en: "A parure of pink and powder glass petals with silver beads: botanical delicacy in necklace and earrings.",
    },
    materials: { it: "Vetro di Murano, argento", en: "Murano glass, silver" },
  },
  {
    id: "gliori-malva",
    category: "gliori",
    image: "/images/gliori-malva.jpg",
    year: "2016",
    client: "Gli Ori di Venezia",
    span: "md:col-span-6",
    aspect: "aspect-[16/10]",
    title: { it: "Collaborazione 2014/15", en: "Collaboration 2014/15" },
    desc: {
      it: "Collana di anelli bruniti e perle ovali acquamarina: geometria e trasparenza in equilibrio.",
      en: "A necklace of burnished rings and aquamarine oval pearls: geometry and transparency in balance.",
    },
    materials: { it: "Vetro di Murano, metallo brunito", en: "Murano glass, burnished metal" },
  },
  {
    id: "gliori-iris",
    category: "gliori",
    image: "/images/gliori-iris.jpg",
    year: "2016",
    client: "Gli Ori di Venezia",
    span: "md:col-span-6",
    aspect: "aspect-[16/10]",
    title: { it: "Collaborazione 2014/15", en: "Collaboration 2014/15" },
    desc: {
      it: "Dischi in vetro pesca e arancio con cristalli sfaccettati: una parure solare e luminosa.",
      en: "Peach and orange glass discs with faceted crystals: a sunny, luminous parure.",
    },
    materials: { it: "Vetro di Murano, cristallo", en: "Murano glass, crystal" },
  },
  {
    id: "gliori-zaira",
    category: "gliori",
    image: "/images/gliori-zaira.jpg",
    year: "2016",
    client: "Gli Ori di Venezia",
    span: "md:col-span-6",
    aspect: "aspect-[16/10]",
    title: { it: "Collaborazione 2014/15", en: "Collaboration 2014/15" },
    desc: {
      it: "Murrine floreali viola e anelli in vetro trasparente: la tecnica della murrina in chiave gioiello.",
      en: "Purple floral murrine and transparent glass rings: the murrina technique turned into jewelry.",
    },
    materials: { it: "Murrine, vetro di Murano", en: "Murrine, Murano glass" },
  },
  {
    id: "gliori-altea",
    category: "gliori",
    image: "/images/gliori-altea.jpg",
    year: "2016",
    client: "Gli Ori di Venezia",
    span: "md:col-span-6",
    aspect: "aspect-[16/10]",
    title: { it: "Collaborazione 2014/15", en: "Collaboration 2014/15" },
    desc: {
      it: "Grappoli di gocce acquamarina e grandi ovali grigio fumo, con orecchini coordinati.",
      en: "Clusters of aquamarine drops and large smoky-grey ovals, with matching earrings.",
    },
    materials: { it: "Vetro di Murano, argento", en: "Murano glass, silver" },
  },
  {
    id: "gliori-dina",
    category: "gliori",
    image: "/images/gliori-dina.jpg",
    year: "2016",
    client: "Gli Ori di Venezia",
    span: "md:col-span-6",
    aspect: "aspect-[16/10]",
    title: { it: "Collaborazione 2014/15", en: "Collaboration 2014/15" },
    desc: {
      it: "Collana, orecchini e bracciale in dischi d'ambra: luce calda in tre movimenti.",
      en: "Necklace, earrings and bracelet in amber discs: warm light in three movements.",
    },
    materials: { it: "Vetro di Murano color ambra", en: "Amber Murano glass" },
  },
  {
    id: "vaccari-smeraldo",
    category: "vaccari",
    image: "/images/vaccari-perle.jpg",
    year: "2012",
    client: "Antonio Vaccari",
    span: "md:col-span-6",
    aspect: "aspect-[3/4]",
    title: { it: "Collaborazione 2013/14", en: "Collaboration 2013/14" },
    desc: {
      it: "Collana multifilo in vetro verde smeraldo su paillettes nere: la sera veneziana.",
      en: "A multi-strand emerald green glass necklace on black sequins: the Venetian evening.",
    },
    materials: { it: "Vetro di Murano", en: "Murano glass" },
  },
  {
    id: "vaccari-turchese",
    category: "vaccari",
    image: "/images/vaccari-perle-2.jpg",
    year: "2012",
    client: "Antonio Vaccari",
    span: "md:col-span-6",
    aspect: "aspect-[16/11]",
    title: { it: "Collaborazione 2013/14", en: "Collaboration 2013/14" },
    desc: {
      it: "Onde nere e perle turchesi indossate con bracciale coordinato: contrasto grafico.",
      en: "Black waves and turquoise pearls worn with a matching bracelet: graphic contrast.",
    },
    materials: { it: "Vetro di Murano, cristallo", en: "Murano glass, crystal" },
  },
  {
    id: "vaccari-lunga-ambra",
    category: "vaccari",
    image: "/images/vaccari-perle-4.jpg",
    year: "2013",
    client: "Antonio Vaccari",
    span: "md:col-span-6",
    aspect: "aspect-[3/4]",
    title: { it: "Collaborazione 2013/14", en: "Collaboration 2013/14" },
    desc: {
      it: "Collana lunga multifilo in perle ambra e viola su camicia bianca: verticalità elegante.",
      en: "A long multi-strand necklace of amber and purple pearls on a white shirt: elegant verticality.",
    },
    materials: { it: "Vetro di Murano", en: "Murano glass" },
  },
  {
    id: "vaccari-ghiaccio",
    category: "vaccari",
    image: "/images/vaccari-perle-5.jpg",
    year: "2013",
    client: "Antonio Vaccari · Limited Edition",
    span: "md:col-span-6",
    aspect: "aspect-[3/4]",
    title: { it: "Collaborazione 2013/14", en: "Collaboration 2013/14" },
    desc: {
      it: "La campagna ufficiale Antonio Vaccari Limited Edition: vetro ghiaccio su nero assoluto.",
      en: "The official Antonio Vaccari Limited Edition campaign: ice glass on absolute black.",
    },
    materials: { it: "Vetro di Murano, foglia d'argento", en: "Murano glass, silver leaf" },
  },

  {
    id: "uomo-campagna",
    category: "uomo",
    image: "/images/uomo-campagna.jpg",
    year: "2018",
    client: "Collezione Uomo",
    span: "md:col-span-7",
    aspect: "aspect-[16/11]",
    title: { it: "Collezione Ever Green 2025/26", en: "Ever Green 2025/26 Collection" },
    desc: {
      it: "La campagna uomo: bracciali in perle di vetro e pelle indossati su giacca biker, tra rock e artigianato.",
      en: "The men's campaign: glass pearl and leather bracelets worn with a biker jacket — between rock and craftsmanship.",
    },
    materials: { it: "Vetro di Murano, pelle, ematite", en: "Murano glass, leather, hematite" },
  },
  {
    id: "uomo-verde",
    category: "uomo",
    image: "/images/uomo-verde.jpg",
    year: "2018",
    client: "Collezione Uomo",
    span: "md:col-span-5",
    aspect: "aspect-[3/4]",
    title: { it: "Collezione Ever Green 2025/26", en: "Ever Green 2025/26 Collection" },
    desc: {
      it: "Perle di vetro verde salvia ed ematite: collana e bracciale pensati al maschile.",
      en: "Sage green glass pearls and hematite: a necklace and bracelet designed for men.",
    },
    materials: { it: "Vetro di Murano, ematite", en: "Murano glass, hematite" },
  },
  {
    id: "uomo-stack",
    category: "uomo",
    image: "/images/uomo-stack.jpg",
    year: "2018",
    client: "Collezione Uomo",
    span: "md:col-span-5",
    aspect: "aspect-[3/4]",
    title: { it: "Collezione Ever Green 2025/26", en: "Ever Green 2025/26 Collection" },
    desc: {
      it: "Bracciali sovrapposti in pelle nera, perle verdi e bronzo: il layering come linguaggio.",
      en: "Stacked bracelets in black leather, green pearls and bronze: layering as a language.",
    },
    materials: { it: "Pelle, vetro, metallo", en: "Leather, glass, metal" },
  },
  {
    id: "uomo-maglia",
    category: "uomo",
    image: "/images/uomo-maglia.jpg",
    year: "2018",
    client: "Collezione Uomo",
    span: "md:col-span-7",
    aspect: "aspect-[4/5]",
    title: { it: "Collezione Ever Green 2025/26", en: "Ever Green 2025/26 Collection" },
    desc: {
      it: "Doppio bracciale in caucciù nero con inserti azzurro e giallo fluo su maglia grigia.",
      en: "Double black rubber bracelet with blue and neon yellow inserts on grey knitwear.",
    },
    materials: { it: "Caucciù, corda tecnica", en: "Rubber, technical cord" },
  },
  {
    id: "uomo-abito",
    category: "uomo",
    image: "/images/uomo-abito.jpg",
    year: "2019",
    client: "Collezione Uomo",
    span: "md:col-span-7",
    aspect: "aspect-[4/5]",
    title: { it: "Collezione Ever Green 2025/26", en: "Ever Green 2025/26 Collection" },
    desc: {
      it: "Bracciale in cavo d'acciaio nero sotto il polsino della camicia: eleganza sartoriale.",
      en: "A black steel cable bracelet under the shirt cuff: sartorial elegance.",
    },
    materials: { it: "Acciaio, metallo nero", en: "Steel, black metal" },
  },
  {
    id: "uomo-turchese-pelle",
    category: "uomo",
    image: "/images/uomo-turchese-pelle.jpg",
    year: "2019",
    client: "MurrinaMurano · Uomo",
    span: "md:col-span-5",
    aspect: "aspect-square",
    title: { it: "Collezione Ever Green 2025/26", en: "Ever Green 2025/26 Collection" },
    desc: {
      it: "Bracciale in cavo d'acciaio nero e argento con fermi in metallo: precisione industriale.",
      en: "A black and silver steel cable bracelet with metal fastenings: industrial precision.",
    },
    materials: { it: "Acciaio, caucciù", en: "Steel, rubber" },
  },
  {
    id: "uomo-evergreen-1",
    category: "uomo",
    image: "/images/uomo-blaze_5994.jpg",
    year: "2025/26",
    client: "Collezione Uomo",
    span: "md:col-span-7",
    aspect: "aspect-[4/5]",
    title: { it: "Collezione Ever Green 2025/26", en: "Ever Green 2025/26 Collection" },
    desc: {
      it: "Doppio bracciale in pelle intrecciata e perle di vetro, portato con nonchalance.",
      en: "A double bracelet of woven leather and glass pearls, worn with nonchalance.",
    },
    materials: { it: "Pelle, vetro di Murano, ematite", en: "Leather, Murano glass, hematite" },
  },
  {
    id: "uomo-evergreen-2",
    category: "uomo",
    image: "/images/uomo-blaze_6057.jpg",
    year: "2025/26",
    client: "Collezione Uomo",
    span: "md:col-span-5",
    aspect: "aspect-[3/4]",
    title: { it: "Collezione Ever Green 2025/26", en: "Ever Green 2025/26 Collection" },
    desc: {
      it: "Bracciali in cavo blu e nero su blazer grigio: eleganza rilassata.",
      en: "Blue and black cable bracelets on a grey blazer: relaxed elegance.",
    },
    materials: { it: "Acciaio, vetro", en: "Steel, glass" },
  },
  {
    id: "uomo-evergreen-3",
    category: "uomo",
    image: "/images/uomo-blaze_6355.jpg",
    year: "2025/26",
    client: "Collezione Uomo",
    span: "md:col-span-5",
    aspect: "aspect-[3/4]",
    title: { it: "Collezione Ever Green 2025/26", en: "Ever Green 2025/26 Collection" },
    desc: {
      it: "Cravatta nera e bracciali in vetro: il dettaglio che firma il look.",
      en: "A black tie and glass bracelets: the detail that signs the look.",
    },
    materials: { it: "Vetro di Murano, metallo", en: "Murano glass, metal" },
  },
  {
    id: "uomo-evergreen-4",
    category: "uomo",
    image: "/images/uomo-blaze_6367.jpg",
    year: "2025/26",
    client: "Collezione Uomo",
    span: "md:col-span-7",
    aspect: "aspect-[4/5]",
    title: { it: "Collezione Ever Green 2025/26", en: "Ever Green 2025/26 Collection" },
    desc: {
      it: "Perle di vetro verdi e blu in primo piano: colore e carattere.",
      en: "Green and blue glass pearls up close: colour and character.",
    },
    materials: { it: "Vetro di Murano, pietre dure", en: "Murano glass, gemstones" },
  },
  {
    id: "uomo-evergreen-5",
    category: "uomo",
    image: "/images/uomo-blaze_6317.jpg",
    year: "2025/26",
    client: "Collezione Uomo",
    span: "md:col-span-7",
    aspect: "aspect-[4/5]",
    title: { it: "Collezione Ever Green 2025/26", en: "Ever Green 2025/26 Collection" },
    desc: {
      it: "Portachiavi con sfera in vetro avorio appeso alla tasca: piccolo gioiello quotidiano.",
      en: "A keychain with an ivory glass sphere hanging from the pocket: an everyday small jewel.",
    },
    materials: { it: "Vetro di Murano, metallo brunito", en: "Murano glass, burnished metal" },
  },
  {
    id: "uomo-evergreen-6",
    category: "uomo",
    image: "/images/uomo-blaze_6392.jpg",
    year: "2025/26",
    client: "Collezione Uomo",
    span: "md:col-span-5",
    aspect: "aspect-[3/4]",
    title: { it: "Collezione Ever Green 2025/26", en: "Ever Green 2025/26 Collection" },
    desc: {
      it: "Stack di bracciali in lava, vetro e metallo: texture a contrasto.",
      en: "A stack of lava, glass and metal bracelets: contrasting textures.",
    },
    materials: { it: "Lava, vetro di Murano, metallo", en: "Lava, Murano glass, metal" },
  },
  {
    id: "uomo-eg-6164",
    category: "uomo",
    image: "/images/uomo-add-blaze-6164.jpg",
    year: "2025/26",
    client: "Collezione Uomo",
    span: "md:col-span-5",
    aspect: "aspect-[3/4]",
    title: { it: "Collezione Ever Green 2025/26", en: "Ever Green 2025/26 Collection" },
    desc: {
      it: "Doppio giro in pelle intrecciata grigia con perla tubolare turchese, su maglia grigia.",
      en: "Double wrap of grey woven leather with a turquoise tube pearl, on grey knit.",
    },
    materials: { it: "Pelle intrecciata, vetro di Murano", en: "Woven leather, Murano glass" },
  },
  {
    id: "uomo-eg-6178",
    category: "uomo",
    image: "/images/uomo-add-blaze-6178.jpg",
    year: "2025/26",
    client: "Collezione Uomo",
    span: "md:col-span-7",
    aspect: "aspect-[4/5]",
    title: { it: "Collezione Ever Green 2025/26", en: "Ever Green 2025/26 Collection" },
    desc: {
      it: "La perla turchese dal polso alla tasca: bracciale e portachiavi coordinati.",
      en: "The turquoise pearl from wrist to pocket: matching bracelet and keychain.",
    },
    materials: { it: "Pelle, vetro di Murano, metallo", en: "Leather, Murano glass, metal" },
  },
  {
    id: "uomo-eg-uomo4",
    category: "uomo",
    image: "/images/uomo-add-uomo-4.jpg",
    year: "2025/26",
    client: "Collezione Uomo",
    span: "md:col-span-5",
    aspect: "aspect-[3/4]",
    title: { it: "Collezione Ever Green 2025/26", en: "Ever Green 2025/26 Collection" },
    desc: {
      it: "Still life: pelle intrecciata grigia e perla tubolare turchese su pelle teal.",
      en: "Still life: grey woven leather and a turquoise tube pearl on teal leather.",
    },
    materials: { it: "Pelle intrecciata, vetro di Murano", en: "Woven leather, Murano glass" },
  },
  {
    id: "uomo-eg-6200",
    category: "uomo",
    image: "/images/uomo-add-blaze-6200.jpg",
    year: "2025/26",
    client: "Collezione Uomo",
    span: "md:col-span-7",
    aspect: "aspect-[4/5]",
    title: { it: "Collezione Ever Green 2025/26", en: "Ever Green 2025/26 Collection" },
    desc: {
      it: "Cavi blu e neri ai due polsi su maglia navy: il blu in tutte le sue profondità.",
      en: "Blue and black cables on both wrists over a navy knit: blue in all its depths.",
    },
    materials: { it: "Acciaio, vetro, pietre dure", en: "Steel, glass, gemstones" },
  },
  {
    id: "uomo-eg-6265",
    category: "uomo",
    image: "/images/uomo-add-blaze-6265.jpg",
    year: "2025/26",
    client: "Collezione Uomo",
    span: "md:col-span-5",
    aspect: "aspect-[3/4]",
    title: { it: "Collezione Ever Green 2025/26", en: "Ever Green 2025/26 Collection" },
    desc: {
      it: "Perle quadrate in vetro bianco-blu effetto porcellana con ematite nera, su denim.",
      en: "Square white-and-blue porcelain-effect glass pearls with black hematite, on denim.",
    },
    materials: { it: "Vetro di Murano, ematite, catena", en: "Murano glass, hematite, chain" },
  },
  {
    id: "uomo-eg-6035",
    category: "uomo",
    image: "/images/uomo-add-blaze-6035.jpg",
    year: "2025/26",
    client: "Collezione Uomo",
    span: "md:col-span-7",
    aspect: "aspect-[4/5]",
    title: { it: "Collezione Ever Green 2025/26", en: "Ever Green 2025/26 Collection" },
    desc: {
      it: "Doppio stack di perle verdi, bronzo e nere su blazer grigio: layering sartoriale.",
      en: "A double stack of green, bronze and black pearls on a grey blazer: sartorial layering.",
    },
    materials: { it: "Vetro di Murano, pietre dure", en: "Murano glass, gemstones" },
  },
  {
    id: "uomo-eg-6278",
    category: "uomo",
    image: "/images/uomo-add-blaze-6278.jpg",
    year: "2025/26",
    client: "Collezione Uomo",
    span: "md:col-span-5",
    aspect: "aspect-[3/4]",
    title: { it: "Collezione Ever Green 2025/26", en: "Ever Green 2025/26 Collection" },
    desc: {
      it: "Stack multicolore in lava e pietre con accenti turchese e arancio.",
      en: "A multicolour lava and gemstone stack with turquoise and orange accents.",
    },
    materials: { it: "Lava, vetro di Murano, pietre dure", en: "Lava, Murano glass, gemstones" },
  },
  {
    id: "uomo-eg-6301",
    category: "uomo",
    image: "/images/uomo-add-blaze-6301.jpg",
    year: "2025/26",
    client: "Collezione Uomo",
    span: "md:col-span-7",
    aspect: "aspect-[4/5]",
    title: { it: "Collezione Ever Green 2025/26", en: "Ever Green 2025/26 Collection" },
    desc: {
      it: "Verde bottiglia e rosso mattone ai due polsi, su field jacket.",
      en: "Bottle green and brick red on both wrists, over a field jacket.",
    },
    materials: { it: "Vetro di Murano, metallo", en: "Murano glass, metal" },
  },
  {
    id: "uomo-eg-6011",
    category: "uomo",
    image: "/images/uomo-add-blaze-6011.jpg",
    year: "2025/26",
    client: "Collezione Uomo",
    span: "md:col-span-7",
    aspect: "aspect-[16/10]",
    title: { it: "Collezione Ever Green 2025/26", en: "Ever Green 2025/26 Collection" },
    desc: {
      it: "Borsone in canvas e pelle con bracciali al polso: il viaggio come stile.",
      en: "A canvas and leather duffle bag with bracelets on the wrist: travel as style.",
    },
    materials: { it: "Canvas, pelle, vetro di Murano", en: "Canvas, leather, Murano glass" },
  },
  {
    id: "uomo-eg-uomo5",
    category: "uomo",
    image: "/images/uomo-add-uomo-5.jpg",
    year: "2025/26",
    client: "Collezione Uomo",
    span: "md:col-span-5",
    aspect: "aspect-[3/4]",
    title: { it: "Collezione Ever Green 2025/26", en: "Ever Green 2025/26 Collection" },
    desc: {
      it: "Still life: pelle marrone intrecciata e perle color terra su legno vissuto.",
      en: "Still life: brown woven leather and earth-toned pearls on weathered wood.",
    },
    materials: { it: "Pelle intrecciata, vetro, acciaio", en: "Woven leather, glass, steel" },
  },
  {
    id: "uomo-eg-uomo2",
    category: "uomo",
    image: "/images/uomo-add-uomo-2.jpg",
    year: "2025/26",
    client: "Collezione Uomo",
    span: "md:col-span-5",
    aspect: "aspect-[3/4]",
    title: { it: "Collezione Ever Green 2025/26", en: "Ever Green 2025/26 Collection" },
    desc: {
      it: "Still life: caucciù nero, perle in legno chiaro e cavo dorato su pelle marrone.",
      en: "Still life: black rubber, light wooden pearls and a golden cable on brown leather.",
    },
    materials: { it: "Caucciù, legno, metallo dorato", en: "Rubber, wood, gilt metal" },
  },
  {
    id: "uomo-eg-6375",
    category: "uomo",
    image: "/images/uomo-add-blaze-6375.jpg",
    year: "2025/26",
    client: "Collezione Uomo",
    span: "md:col-span-7",
    aspect: "aspect-[16/10]",
    title: { it: "Collezione Ever Green 2025/26", en: "Ever Green 2025/26 Collection" },
    desc: {
      it: "Corde nere, grigie e blu su fondo scuro: essenzialità notturna.",
      en: "Black, grey and blue cords on a dark backdrop: nocturnal essentiality.",
    },
    materials: { it: "Corda tecnica, metallo", en: "Technical cord, metal" },
  },
  {
    id: "feel-cuore",
    category: "feel",
    image: "/images/feel-925.jpg",
    year: "2014",
    client: "MurrinaMurano · Feel 925",
    span: "md:col-span-7",
    aspect: "aspect-[16/11]",
    title: { it: "Collezzione argento 925 2022/23", en: "925 Silver Collection 2022/23" },
    desc: {
      it: "La linea Feel 925: argento 925 e cuori in vetro di Murano, un classico contemporaneo del marchio.",
      en: "The Feel 925 line: 925 silver and Murano glass hearts — a contemporary classic of the brand.",
    },
    materials: { it: "Argento 925, vetro di Murano", en: "925 silver, Murano glass" },
  },
  {
    id: "feel-still",
    category: "feel",
    image: "/images/feel-925-2.jpg",
    year: "2014",
    client: "MurrinaMurano · Feel 925",
    span: "md:col-span-5",
    aspect: "aspect-[3/4]",
    title: { it: "Collezzione argento 925 2022/23", en: "925 Silver Collection 2022/23" },
    desc: {
      it: "Perle in vetro colorato e argento nella loro forma più pura: il prodotto come protagonista.",
      en: "Coloured glass pearls and silver in their purest form: the product as protagonist.",
    },
    materials: { it: "Argento 925, vetro di Murano", en: "925 silver, Murano glass" },
  },
  {
    id: "feel-campagna",
    category: "feel",
    image: "/images/hero-secondary.jpg",
    year: "2014",
    client: "MurrinaMurano · Feel 925",
    span: "md:col-span-5",
    aspect: "aspect-[3/4]",
    title: { it: "Collezzione argento 925 2022/23", en: "925 Silver Collection 2022/23" },
    desc: {
      it: "La campagna Feel 925: cascate di perle in vetro colorato su rossetto rosso, energia pop.",
      en: "The Feel 925 campaign: cascades of coloured glass pearls against red lipstick — pop energy.",
    },
    materials: { it: "Vetro di Murano, argento", en: "Murano glass, silver" },
  },
  {
    id: "feel-indossati-1",
    category: "feel",
    image: "/images/feel-worn.jpg",
    year: "2014",
    client: "MurrinaMurano · Feel 925",
    span: "md:col-span-7",
    aspect: "aspect-[4/5]",
    title: { it: "Collezzione argento 925 2022/23", en: "925 Silver Collection 2022/23" },
    desc: {
      it: "Feel 925 indossato: ritmo e colore al polso, tra perle di vetro e maglie d'argento.",
      en: "Feel 925 worn: rhythm and colour on the wrist, between glass pearls and silver links.",
    },
    materials: { it: "Argento 925, vetro di Murano", en: "925 silver, Murano glass" },
  },
  {
    id: "feel-indossati-2",
    category: "feel",
    image: "/images/feel-worn-2.jpg",
    year: "2014",
    client: "MurrinaMurano · Feel 925",
    span: "md:col-span-5",
    aspect: "aspect-[3/4]",
    title: { it: "Collezzione argento 925 2022/23", en: "925 Silver Collection 2022/23" },
    desc: {
      it: "Dettaglio indossato della collezione: la luce del vetro dialoga con la pelle.",
      en: "A worn detail from the collection: the light of glass in dialogue with the skin.",
    },
    materials: { it: "Argento 925, vetro di Murano", en: "925 silver, Murano glass" },
  },
  {
    id: "feel-moodboard",
    category: "feel",
    image: "/images/sketch-feel.jpg",
    year: "2014",
    client: "MurrinaMurano · Feel 925",
    span: "md:col-span-7",
    aspect: "aspect-[16/11]",
    title: { it: "Feel 925 — Moodboard", en: "Feel 925 — Moodboard" },
    desc: {
      it: "Bozzetti, palette e prime prove: la fase di ricerca dietro la collezione Feel 925.",
      en: "Sketches, palettes and first trials: the research phase behind the Feel 925 collection.",
    },
    materials: { it: "Bozzetti, carta, prove colore", en: "Sketches, paper, colour trials" },
  },
  {
    id: "feel-dettaglio-1",
    category: "feel",
    image: "/images/feel-dettaglio-1.jpg",
    year: "2014",
    client: "MurrinaMurano · Feel 925",
    span: "md:col-span-5",
    aspect: "aspect-[3/4]",
    title: { it: "Collezzione argento 925 2022/23", en: "925 Silver Collection 2022/23" },
    desc: {
      it: "Macro sulle perle di vetro colorato: ogni perlina è una piccola architettura di luce.",
      en: "Close-up on the coloured glass pearls: each bead a small architecture of light.",
    },
    materials: { it: "Vetro di Murano, argento", en: "Murano glass, silver" },
  },
  {
    id: "feel-dettaglio-2",
    category: "feel",
    image: "/images/feel-dettaglio-2.jpg",
    year: "2014",
    client: "MurrinaMurano · Feel 925",
    span: "md:col-span-7",
    aspect: "aspect-[16/11]",
    title: { it: "Collezzione argento 925 2022/23", en: "925 Silver Collection 2022/23" },
    desc: {
      it: "Il ritmo delle perle indossate da vicino: colore, trasparenza e movimento.",
      en: "The rhythm of the worn pearls up close: colour, transparency and movement.",
    },
    materials: { it: "Vetro di Murano, argento", en: "Murano glass, silver" },
  },
];
